<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers">
      <button class="btn primary small outline" @click="deleteBusinessArea">
        {{ $t('button.delete') }}
      </button>
      <button class="btn primary small" @click="updateView">
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
    </div>

    <el-dialog
      :title="!isEdit ? 'Thêm khu kinh doanh' : 'Sửa khu kinh doanh'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã khu</div>
                  <validation-provider
                    rules="required|max:20|no_special"
                    name="Mã khu kinh doanh"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="form.code"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label" />

                  <div class="checkbox-wrap" style="display: block !important">
                    <input
                      id="cpSpdTp1"
                      v-model="form.is_issue_invoice"
                      type="checkbox"
                    />
                    <label for="cpSpdTp1">Phát hành hoá đơn khi trả chỗ</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên khu</div>
                  <validation-provider rules="required" name="Tên khu">
                    <div class="child-w-80">
                      <input
                        v-model="form.name"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label" />

                  <div class="checkbox-wrap" style="display: block !important">
                    <input
                      id="cpSpdTp2"
                      v-model="form.auto_process_consum"
                      type="checkbox"
                    />
                    <label for="cpSpdTp2">Tự động xử lý hàng tiêu thụ</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tên tiếng Anh</div>
                  <validation-provider rules="required" name="Tên tiếng Anh">
                    <div class="child-w-80">
                      <input
                        v-model="form.english_name"
                        type="text"
                        :disabled="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label" />

                  <div class="checkbox-wrap" style="display: block !important">
                    <input
                      id="cpSpdTp3"
                      v-model="form.include_tax_fee"
                      type="checkbox"
                      @change="includeInputTax"
                    />
                    <label for="cpSpdTp3">Bao gồm thuế, phí</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Kho</div>
                  <validation-provider rules="required" name="Kho">
                    <div class="child-w-80">
                      <el-select v-model="form.warehouse_id">
                        <el-option
                          v-for="warehouse in warehouseList"
                          :key="warehouse.id"
                          :value="warehouse.id"
                          :label="warehouse.name"
                        ></el-option>
                      </el-select>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label" />

                  <div class="checkbox-wrap" style="display: block !important">
                    <input
                      id="cpSpdTp4"
                      v-model="form.manual_tax_fee"
                      type="checkbox"
                      :disabled="form.include_tax_fee"
                      name="manual_tax_fee"
                    />
                    <label for="cpSpdTp4"
                      >Cho phép nhập mức thuế, phí thủ công</label
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Loại hình kinh doanh</div>
                  <validation-provider
                    rules="required"
                    name="Loại hình kinh doanh"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="rowsType"
                      :columns="columnsType"
                      index-field="id"
                      :selected-index-field-value="form.business_type_id"
                      :value="form.business_type_id"
                      @selectionChanged="onSelectRowType"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.desc }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label"></div>
                  <div style="display: flex; align-item: center; gap: 10px">
                    <div
                      class="checkbox-wrap"
                      style="display: block !important"
                    >
                      <input
                        id="cpSpdTp5"
                        v-model="form.is_audit_alert"
                        type="checkbox"
                        @change="toggleAlert"
                      />
                      <label for="cpSpdTp5">Cảnh báo kiểm toán</label>
                    </div>
                    <el-time-picker
                      v-model="form.audit_alert"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100px"
                      :disabled="!form.is_audit_alert"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Giao dịch mặc định</div>
                  <validation-provider
                    rules="required"
                    name="Giao dịch mặc định"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="rowTransactionDefault"
                      :columns="columnsTransaction"
                      index-field="sub_transaction_id"
                      :selected-index-field-value="form.sub_default_trans"
                      :value="form.sub_default_trans"
                      :dropdown-width="400"
                      @selectionChanged="onSelectRowDefaultTrans"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        {{ selectedData?.transaction_desc }}
                        {{ selectedData ? '-' : '' }}
                        {{ selectedData?.sub_transaction_desc }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Phí giao dịch</div>
                  <!-- rules="required_if:form.manual_tax_fee,true" -->
                  <validation-provider
                    :rules="{
                      required_if: {
                        target: 'form.include_tax_fee',
                        values: [false]
                      }
                    }"
                    name="Phí giao dịch"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="rowsFee"
                      :columns="columnsTax"
                      index-field="id"
                      :selected-index-field-value="form.fee_id"
                      :value="form.fee_id"
                      :disabled="!form.manual_tax_fee"
                      @selectionChanged="onSelectRowFee"
                    >
                      <template #value="{ selectedValue: selectedData }">
                        {{ selectedData?.name }} {{ selectedData?.code }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Mã giao dịch phí huỷ</div>
                  <validation-provider
                    rules="required"
                    name="Mã giao dịch phí huỷ"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="rowTransactionCancel"
                      :columns="columnsTransaction"
                      index-field="sub_transaction_id"
                      :dropdown-width="400"
                      :selected-index-field-value="
                        form.sub_cancel_fee_trans_code
                      "
                      :value="form.sub_cancel_fee_trans_code"
                      @selectionChanged="onSelectRowCancelTrans"
                    >
                      <template #value="{ selectedValue: selectedData }">
                        {{ selectedData?.transaction_desc }}
                        {{ selectedData ? '-' : '' }}
                        {{ selectedData?.sub_transaction_desc }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Thuế giao dịch</div>
                  <!-- rules="required_if:form.manual_tax_fee, true" -->
                  <validation-provider
                    :rules="{
                      required_if: {
                        target: 'include_tax_fee',
                        values: [false]
                      }
                    }"
                    name="Thuế giao dịch"
                  >
                    <select-with-search-table
                      style="width: 100%"
                      :rows="rowsTax"
                      :columns="columnsTax"
                      index-field="id"
                      :selected-index-field-value="form.tax_id"
                      :value="form.tax_id"
                      :disabled="!form.manual_tax_fee"
                      @selectionChanged="onSelectRowTax"
                    >
                      <template #value="{ selectedValue: selectedData }">
                        {{ selectedData?.name }} {{ selectedData?.code }}
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small outline"
            @click="updateBusinessArea"
          >
            {{ $t('button.update') }}
          </button>
          <button
            v-else
            class="btn primary small outline"
            @click="addBusinessArea"
          >
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders.js'
import RightPanel from '@/components/RightPanel'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getListTaxApi } from '@/api/configuration/accounting/tax.js'
import { getListChargeServiceApi } from '@/api/configuration/accounting/chargeService.js'
import { getBusinessTypeApi } from '@/api/common/code_base'

import bus from '@/utils/bus'
import {
  getListBusinessAreaApi,
  getBusinessAreaByIdApi,
  addBusinessAreaApi,
  deleteBusinessAreaApi,
  updateBusinessAreaApi,
  getCancelTransactionApi,
  getDefaultTransactionApi,
  getWarehouseApi
} from '@/api/businessArea/businessArea'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderCheckboxReadonly,
    SelectWithSearchTable,
    Breadcrumb,
    RightPanel
  },
  data() {
    return {
      loading: false,
      titlePopup: 'Thêm mới tòa nhà',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        page_size: 10,
        page_num: 1,
        order_tp: 'ASC'
      },
      form: {
        code: '',
        name: '',
        english_name: '',
        warehouse_id: null,
        business_type_id: null,
        sub_default_trans: 0,
        sub_cancel_fee_trans_code: null,
        is_issue_invoice: false,
        auto_process_consum: false,
        include_tax_fee: true,
        manual_tax_fee: false,
        is_audit_alert: false,
        audit_alert: null,
        fee_id: null,
        tax_id: null
      },
      defaultForm: {
        code: '',
        name: '',
        english_name: '',
        warehouse_id: null,
        business_type_id: null,
        sub_default_trans: null,
        sub_cancel_fee_trans_code: null,
        is_issue_invoice: false,
        auto_process_consum: false,
        include_tax_fee: true,
        manual_tax_fee: false,
        is_audit_alert: false,
        audit_alert: null,
        fee_id: null,
        tax_id: null
      },
      businessType: [],
      columnsTax: [
        {
          headerName: 'Mã',
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 80,
          maxwidth: 100,
          sortable: false
        },

        {
          headerName: 'Mô tả',
          field: 'desc',
          // cellClass: "grid-cell-centered",
          // width: 100,
          flex: 1,
          sortable: false
        }
      ],
      warehouseList: [],
      rowsTax: [],
      rowsFee: [],
      columnsTransaction: [
        {
          headerName: 'Mã giao dịch',
          field: 'transaction_desc',
          // cellClass: "grid-cell-centered",
          maxwidth: 100,
          minWidth: 80,
          sortable: false
        },

        {
          headerName: 'Mã giao dịch phụ',
          field: 'sub_transaction_desc',
          // maxwidth: 100,
          flex: 1,

          // cellClass: "grid-cell-centered",
          sortable: false
        }
      ],
      rowTransactionDefault: [],
      rowTransactionCancel: [],
      columnsType: [
        {
          headerName: 'Loại hình',
          field: 'desc',
          // cellClass: "grid-cell-centered",
          sortable: false,
          flex: 1
        }
      ],
      rowsType: [],

      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
          // cellStyle: {'padding-left': '12px'}
        },
        {
          headerName: 'STT',
          field: 'no',
          // cellClass: "grid-cell-centered",
          minWidth: 70,
          maxWidth: 80,
          sortable: false
        },

        {
          headerName: 'Mã khu kinh doanh',
          field: 'code',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
        },
        {
          headerName: 'Tên',
          field: 'name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Bao gồm thuế phí',
          field: 'include_tax_fee',
          maxWidth: 150,
          minWidth: 120,
          sortable: false,
          cellRenderer: 'CellRenderCheckboxReadonly'
          //   cellRendererParams: (params) => {
          //     return {
          //       color: params.data.color,
          //     };
          //   },
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Kho',
          field: 'warehouse_name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: 'Cảnh báo kiểm toán',
          field: 'audit_alert',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetBuildingInfo()
    }
  },
  created() {
    this.getTaxList()
    this.getFeeList()
    this.getBusinessType()
    this.getCancelTransaction()
    this.getDefaultTransaction()
    this.getWarehouseList()
  },

  mounted() {
    this.attachData()
  },

  methods: {
    async getBusinessType() {
      let data = await getBusinessTypeApi()
      this.rowsType = data.data
    },
    async getWarehouseList() {
      let data = await getWarehouseApi()
      this.warehouseList = data.data
    },
    async getDefaultTransaction() {
      let data = await getDefaultTransactionApi()
      this.rowTransactionDefault = data.data
    },
    async getCancelTransaction() {
      let data = await getCancelTransactionApi()
      this.rowTransactionCancel = data.data
    },
    async getTaxList() {
      let data = await getListTaxApi()
      this.rowsTax = data.data
    },
    async getFeeList() {
      let data = await getListChargeServiceApi()
      this.rowsFee = data.data
    },
    onSelectRowDefaultTrans(val) {
      this.form.sub_default_trans = val.sub_transaction_id
    },
    onSelectRowCancelTrans(val) {
      this.form.sub_cancel_fee_trans_code = val.sub_transaction_id
    },
    onSelectRowTax(val) {
      this.form.tax_id = val.id
    },
    onSelectRowFee(val) {
      this.form.fee_id = val.id
    },
    onSelectRowType(val) {
      this.form.business_type_id = val.id
    },
    onRefresh(data) {
      let params = {
        order_by: data.orderBy,
        order_tp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.page_num = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.page_size = pageSize
      this.searchParams.page_num = 1
      await this.attachData()
    },
    includeInputTax() {
      if (this.form.include_tax_fee) {
        this.form.fee_id = null
        this.form.tax_id = null
        this.form.manual_tax_fee = false
      }
    },
    toggleAlert() {
      this.form.audit_alert = ''
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      let data = await getListBusinessAreaApi(this.searchParams)
      this.loading = false
      // bus.$emit('endLoader')
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.page_size)
      this.currentPage = data.data.length == 0 ? 0 : data.page_num
    },
    async addBusinessArea() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addBusinessAreaApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async updateBusinessArea() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await updateBusinessAreaApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },

    async deleteBusinessArea() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)
      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá khu kinh doanh này?', () => {
          deleteBusinessAreaApi(id_list)
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    async updateView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        // const rowData = rowsSelected[0];
        this.isEdit = true

        this.dialogFormVisible = true
        let data = await getBusinessAreaByIdApi(rowsSelected[0].id)
        this.form = { ...data.data }
        this.form.is_audit_alert = !(this.form.audit_alert == '')
      }
    },
    resetBuildingInfo() {
      this.form = { ...this.defaultForm }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
